export default __webpack_public_path__ + "static/media/AnggotaNavPoint.8b78ee03.png";